//CORE
import React from "react";
import ReactExport from "react-data-export";
import moment from "moment-timezone";

//REDUX
import reduxStore from "store/";

//@MATERIAL
import CustomButton from "components/Buttons/custom"
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Switch from "@material-ui/core/Switch";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

//FUNCTIONS
import { translate, getDate } from "functions/";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const useStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            borderRadius: 12,
            minHeight: '60vh',
            maxHeight: '85vh'
        }
    },
    dialogTitle: {
        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        color: 'white',
        padding: theme.spacing(2),
        '& .MuiTypography-h6': {
            fontSize: '1.2rem',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1)
        }
    },
    dialogContent: {
        padding: theme.spacing(2),
        backgroundColor: '#fafafa'
    },
    sectionCard: {
        marginBottom: theme.spacing(2),
        borderRadius: 8,
        boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
        border: '1px solid #e0e0e0'
    },
    sectionHeader: {
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #e0e0e0',
        padding: theme.spacing(1, 2),
        '& .MuiCardHeader-title': {
            fontSize: '1rem',
            fontWeight: 600,
            color: '#333'
        },
        '& .MuiCardHeader-avatar': {
            marginRight: theme.spacing(1)
        }
    },
    sectionContent: {
        padding: theme.spacing(2)
    },
    textField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 6,
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#2196F3'
            }
        },
        '& .MuiFormLabel-root': {
            fontSize: '0.9rem'
        },
        marginBottom: theme.spacing(1)
    },
    switchContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0.75, 1.5),
        backgroundColor: '#f5f5f5',
        borderRadius: 6,
        marginBottom: theme.spacing(0.75)
    },
    columnGrid: {
        maxHeight: 250,
        overflowY: 'auto',
        padding: theme.spacing(1),
        border: '1px solid #e0e0e0',
        borderRadius: 6,
        backgroundColor: 'white'
    },
    columnItem: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0.25, 0.75),
        borderRadius: 4,
        transition: 'background-color 0.2s',
        '&:hover': {
            backgroundColor: '#f0f0f0'
        }
    },
    selectedCount: {
        fontSize: '0.85rem',
        color: '#666',
        fontWeight: 500
    },
    actionButtons: {
        padding: theme.spacing(1.5, 2),
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #e0e0e0'
    },
    exportButton: {
        borderRadius: 6,
        padding: theme.spacing(0.75, 2),
        fontWeight: 600,
        textTransform: 'none',
        background: 'linear-gradient(45deg, #4CAF50 30%, #45A049 90%)',
        '&:hover': {
            background: 'linear-gradient(45deg, #45A049 30%, #4CAF50 90%)'
        }
    },
    cancelButton: {
        borderRadius: 6,
        padding: theme.spacing(0.75, 2),
        fontWeight: 600,
        textTransform: 'none'
    },
    previewChip: {
        margin: theme.spacing(0.25),
        backgroundColor: '#e3f2fd',
        color: '#1976d2',
        height: 24,
        fontSize: '0.75rem'
    },
    compactSection: {
        '& .MuiTypography-body1': {
            fontSize: '0.9rem'
        },
        '& .MuiTypography-body2': {
            fontSize: '0.8rem'
        }
    }
}));

function ExportAll(props) {
    const classes = useStyles()
    const [dataSet, setDataSet] = React.useState([])
    const [userDataSet, setUserDataSet] = React.useState([])
    const [showCustomDialog, setShowCustomDialog] = React.useState(false)
    const [customExportOptions, setCustomExportOptions] = React.useState({
        fileName: props.fileName || "exportBoard",
        mainSheetName: "DADOS-PRINCIPAIS",
        userSheetName: "POR-USUARIO",
        includeMainSheet: true,
        includeUserSheet: true,
        selectedColumns: {}
    })
    const [columns, setcolumns] = React.useState([{
        label: translate('$__step', 1),
        value: 'step'
    }, {
        label: translate('$__cardCode', 1),
        value: 'cardCode'
    }, {
        label: translate('$__ref1', 1),
        value: 'ref1'
    }, {
        label: translate('$__ref2', 1),
        value: 'ref2'
    }, {
        label: translate('$__name', 1),
        value: 'name'
    }, {
        label: translate('$__description', 1),
        value: 'description'
    }, {
        label: translate('$__value', 1),
        value: 'value'
    }, {
        label: translate('$__startDate', 1),
        value: 'startDate'
    }, {
        label: translate('$__endDate', 1),
        value: 'endDate'
    }, {
        label: translate('$__priority', 1),
        value: 'priority'
    }, {
        label: translate('$__risk', 1),
        value: 'risk'
    }, {
        label: translate('$__complexity', 1),
        value: 'complexity'
    }, {
        label: translate('$__impact', 1),
        value: 'impact'
    }, {
        label: translate('$__tags', 1),
        value: 'tags'
    }, {
        label: translate('$__responsive', 1),
        value: 'responsive'
    }, {
        label: translate('$__createdBy', 1),
        value: 'createdBy'
    }, {
        label: translate('$__createdAt', 1),
        value: 'created_at'
    }, {
        label: translate('$__updatedAt', 1),
        value: 'updated_at'
    }])


    const [usersColumns, setusersColumns] = React.useState([{
        label: translate('$__cardCode', 1),
        value: 'cardCode'
    }, {
        label: translate('$__user', 1),
        value: 'user'
    }, {
        label: translate('$__access', 1),
        value: 'level'
    }, {
        label: translate('$__isResposible', 1),
        value: 'responsible'
    }])
    const { db, forms } = reduxStore.getState()


    // Função para garantir que todos os valores sejam strings válidas
    const sanitizeValue = (value) => {
        if (value === null || value === undefined) {
            return "";
        }

        // Converte para string e remove caracteres problemáticos
        let stringValue = String(value);

        // Remove caracteres de controle que podem causar problemas no Excel
        stringValue = stringValue.replace(/[\x00-\x1F\x7F]/g, '');

        // Limita o tamanho para evitar problemas de memória (Excel tem limite de ~32k caracteres por célula)
        if (stringValue.length > 32000) {
            stringValue = stringValue.substring(0, 32000) + "...";
        }

        return stringValue;
    }

    const getNormalizedFormFieldId = React.useCallback((fieldId) => {
        if (!fieldId) return ""

        const parsedFieldId = String(fieldId)
        return parsedFieldId.substr(0, 1) === "f" ? parsedFieldId : `f${parsedFieldId}`
    }, [])

    const getCardCustomFieldValue = React.useCallback((card, fieldId) => {
        if (!card || !fieldId) return undefined

        const normalizedFieldId = getNormalizedFormFieldId(fieldId)

        if (card[normalizedFieldId] !== undefined) return card[normalizedFieldId]
        if (card[fieldId] !== undefined) return card[fieldId]

        return undefined
    }, [getNormalizedFormFieldId])

    const getAllUsedFormsFields = React.useCallback((kanbanData) => {
        const usedFields = []
        const includedFields = new Set()

        Object.keys(kanbanData?.columns || {}).forEach((columnId) => {
            const column = kanbanData.columns[columnId]

            ;(column?.items || []).forEach((card) => {
                const detectedFormId = card?.formId || db.cards[columnId]?.form
                const form = detectedFormId ? forms[detectedFormId] : null

                if (!form?.elements) return

                let formElements = []

                try {
                    formElements = JSON.parse(form.elements) || []
                } catch (error) {
                    console.warn(`Erro ao processar formulário ${detectedFormId}:`, error)
                    return
                }

                formElements.forEach((field) => {
                    const normalizedFieldId = sanitizeValue(getNormalizedFormFieldId(field?.id))

                    if (!normalizedFieldId || includedFields.has(normalizedFieldId)) return

                    includedFields.add(normalizedFieldId)
                    usedFields.push({
                        label: sanitizeValue(field?.name || field?.label || normalizedFieldId),
                        value: normalizedFieldId,
                        originalId: field?.id,
                        type: field?.type || "text",
                        formId: detectedFormId
                    })
                })
            })
        })

        return usedFields
    }, [db.cards, forms, getNormalizedFormFieldId])

    const mergeColumns = React.useCallback((currentColumns, additionalColumns = []) => {
        const mergedColumns = []
        const includedValues = new Set()

        ;[...currentColumns, ...additionalColumns].forEach((column) => {
            if (!column?.value || includedValues.has(column.value)) return

            includedValues.add(column.value)
            mergedColumns.push(column)
        })

        return mergedColumns
    }, [])

    // Função para validar e sanitizar nomes de arquivos
    const sanitizeFileName = (fileName) => {
        return sanitizeValue(fileName)
            .replace(/[^\w\s-]/g, '') // Remove caracteres especiais
            .replace(/\s+/g, '-') // Substitui espaços por hífens
            .substring(0, 50) // Limita o tamanho do nome
    }

    // Função para validar e sanitizar nomes de abas
    const sanitizeSheetName = (sheetName) => {
        return sanitizeValue(sheetName)
            .replace(/[\\\/\?\*\[\]]/g, '') // Remove caracteres não permitidos em nomes de abas
            .substring(0, 30) // Excel tem limite de 31 caracteres para nomes de abas
    }

    // Inicializar opções de colunas quando as colunas mudarem
    React.useEffect(() => {
        if (columns.length > 0) {
            const selectedColumns = {}
            columns.forEach(col => {
                selectedColumns[col.value] = true
            })
            setCustomExportOptions(prev => ({
                ...prev,
                selectedColumns
            }))
        }
    }, [columns])

    const handleCustomExportChange = (field, value) => {
        setCustomExportOptions(prev => ({
            ...prev,
            [field]: value
        }))
    }

    const handleColumnSelectionChange = (columnValue, checked) => {
        setCustomExportOptions(prev => ({
            ...prev,
            selectedColumns: {
                ...prev.selectedColumns,
                [columnValue]: checked
            }
        }))
    }

    // Função para preview das configurações
    const getExportPreview = () => {
        const selectedCols = Object.values(customExportOptions.selectedColumns).filter(Boolean).length
        const totalSheets = (customExportOptions.includeMainSheet ? 1 : 0) + (customExportOptions.includeUserSheet ? 1 : 0)

        return {
            selectedColumns: selectedCols,
            totalColumns: columns.length,
            totalSheets,
            estimatedRows: dataSet.length + userDataSet.length
        }
    }

    const mountDataFn = async (d) => {
        //reduxStore.getState().forms[props.formId].boardColumns

        let access = {
            ["0"]: translate('$__reader', 1),
            ["1"]: translate('$__executioner', 1),
            ["2"]: translate('$__collaborator', 1),
            ["3"]: translate('$__collaborator', 1),
            ["4"]: translate('$__supervisor', 1),
            ["5"]: translate('$__admin', 1)
        }

        let mountData = []
        let mountUsersData = []
        let customFields = mergeColumns(columns, getAllUsedFormsFields(d))

        if (customFields.length > 0)
            setcolumns(customFields)

        Object.keys(d.columns).forEach(col => {
            const columnName = sanitizeValue(db.cards[col]?.name || "")
            if (d.columns[col]?.items?.length > 0) {
                d.columns[col].items.forEach(card => {
                    let newLine = {}

                    customFields.forEach(cf => {
                        let xl = ""

                        try {
                            if (cf.value === 'updated_at' || cf.value === 'created_at') {
                                xl = getDate(card[cf.value]?.low || card[cf.value], "YYYY-MM-DD HH:mm") || ""
                            } else if (cf.value === 'startDate' || cf.value === 'endDate') {
                                if (card[cf.value]?.low || card[cf.value]) {
                                    xl = getDate(card[cf.value]?.low || card[cf.value], "YYYY-MM-DD HH:mm") || ""
                                } else {
                                    xl = ""
                                }
                            } else if (cf.value === 'createdBy') {
                                xl = card._createdBy?.name || ""
                            } else if (cf.value === 'responsive') {
                                const responsibleUser = Object.keys(card._users || {}).find(a => card._users[a]?.isResponsible)
                                const adminUser = Object.keys(card._users || {}).find(a => card._users[a]?.access === "5")
                                xl = responsibleUser || adminUser || ""
                            } else if (cf.value === 'cardCode') {
                                xl = card._cardCode || ""
                            } else if (cf.value === "tags" && card._tags && Array.isArray(card._tags)) {
                                xl = card._tags
                                    .filter(a => a?.label)
                                    .map(a => a.label)
                                    .join(" | ")
                            } else if (cf.value !== "tags" && cf.value !== "cardCode") {
                                const cardValue = getCardCustomFieldValue(card, cf.originalId || cf.value)

                                if (cardValue !== undefined) {
                                    if (typeof cardValue === 'object' && cardValue !== null) {
                                        if (cardValue.low !== undefined) {
                                            xl = String(cardValue.low)
                                        } else if (Array.isArray(cardValue)) {
                                            xl = cardValue.join(" | ")
                                        } else if (cf.type === "file" && (cardValue.url || cardValue.name)) {
                                            xl = cardValue.name || cardValue.url
                                        } else {
                                            xl = JSON.stringify(cardValue)
                                        }
                                    } else {
                                        xl = String(cardValue)
                                    }

                                    if (cf.type === 'date' && xl) {
                                        const parsedDate = moment(xl, ["YYYY-MM-DD", "YYYY-MM-DD HH:mm", moment.ISO_8601], true)
                                        if (parsedDate.isValid()) {
                                            xl = parsedDate.format("YYYY-MM-DD")
                                        }
                                    }
                                }
                            }
                        } catch (error) {
                            console.warn(`Erro ao processar campo ${cf.value}:`, error)
                            xl = ""
                        }

                        newLine[cf.value] = sanitizeValue(xl)
                    })

                    const existingCard = mountData.find(a => a.cardCode === newLine.cardCode)
                    if (!existingCard) {
                        mountData.push({
                            ...newLine,
                            step: sanitizeValue(columnName)
                        })
                    }

                    // Processamento dos usuários
                    Object.keys(card._users || {}).forEach(us => {
                        const userInfo = card._users[us]
                        const existingUserCard = mountUsersData.find(a =>
                            a.cardCode === newLine.cardCode && a.user === userInfo.name
                        )
                        if (userInfo && !existingUserCard) {
                            mountUsersData.push({
                                cardCode: sanitizeValue(newLine.cardCode),
                                user: sanitizeValue(userInfo.name || ""),
                                responsible: userInfo.isResponsible ? "Sim" : "Não",
                                level: sanitizeValue(access[String(userInfo.access || "0").substring(0, 1)] || "")
                            })
                        }
                    })
                })
            }
        })

        setUserDataSet(mountUsersData)
        setDataSet(mountData)
    }

    React.useEffect(() => {
        if (props.data)
            mountDataFn(props.data)
    }, [props.data])


    if (dataSet.length === 0)
        return (
            <div>Sem informações para exportar</div>
        )

    // Renderizar componente de exportação personalizada
    const renderCustomExport = () => {
        const selectedColumns = columns.filter(col => customExportOptions.selectedColumns[col.value])
        const selectedUserColumns = usersColumns.filter(col => customExportOptions.selectedColumns[col.value] !== false)

        const customDataSet = dataSet.map(row => {
            const filteredRow = {}
            selectedColumns.forEach(col => {
                filteredRow[col.value] = row[col.value]
            })
            return filteredRow
        })

        const customUserDataSet = userDataSet.map(row => {
            const filteredRow = {}
            selectedUserColumns.forEach(col => {
                filteredRow[col.value] = row[col.value]
            })
            return filteredRow
        })

        const sanitizedFileName = sanitizeFileName(customExportOptions.fileName)
        const timestamp = moment().format('YYYYMMDD-HHmmss')
        const finalFileName = `${sanitizedFileName}-${timestamp}`

        return (
            <ExcelFile
                filename={finalFileName}
                element={
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.exportButton}
                        startIcon={<Icon>file_download</Icon>}
                        onClick={() => setShowCustomDialog(false)}
                    >
                        Exportar Personalizado
                    </Button>
                }
            >
                {customExportOptions.includeMainSheet && (
                    <ExcelSheet
                        data={customDataSet}
                        name={sanitizeSheetName(customExportOptions.mainSheetName)}
                    >
                        {selectedColumns.map((a, ai) => (
                            <ExcelColumn
                                key={ai}
                                style={{
                                    alignment: { wrapText: true },
                                    numFmt: '@'
                                }}
                                label={sanitizeValue(a.label)}
                                value={a.value}
                            />
                        ))}
                    </ExcelSheet>
                )}
                {customExportOptions.includeUserSheet && (
                    <ExcelSheet
                        data={customUserDataSet}
                        name={sanitizeSheetName(customExportOptions.userSheetName)}
                    >
                        {selectedUserColumns.map((a, ai) => (
                            <ExcelColumn
                                key={ai}
                                style={{
                                    alignment: { wrapText: true },
                                    numFmt: '@'
                                }}
                                label={sanitizeValue(a.label)}
                                value={a.value}
                            />
                        ))}
                    </ExcelSheet>
                )}
            </ExcelFile>
        )
    }

    // Nome do arquivo sanitizado para compatibilidade (método antigo)
    const sanitizedFileName = sanitizeFileName(props.fileName || "exportBoard")
    const timestamp = moment().format('YYYYMMDD-HHmmss')
    const finalFileName = `${sanitizedFileName}-${timestamp}`

    return (
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {/* Exportação Rápida (método antigo) */}
            <ExcelFile
                filename={finalFileName}
                element={
                    <CustomButton
                        title={translate("$__export")}
                        text={translate("$__export")}
                        icon={"file_download"}
                        size={"25px"}
                    />
                }
            >
                <ExcelSheet
                    data={dataSet}
                    name={sanitizedFileName.substring(0, 30)} // Excel tem limite de 31 caracteres para nomes de abas
                >
                    {columns.map((a, ai) => {
                        return (
                            <ExcelColumn
                                key={ai}
                                style={{
                                    alignment: { wrapText: true },
                                    numFmt: '@' // Força formato de texto
                                }}
                                label={sanitizeValue(a.label)}
                                value={a.value}
                            />
                        )
                    })}
                </ExcelSheet>
                <ExcelSheet
                    data={userDataSet}
                    name={'POR-USUARIO'}
                >
                    {usersColumns.map((a, ai) => {
                        return (
                            <ExcelColumn
                                key={ai}
                                style={{
                                    alignment: { wrapText: true },
                                    numFmt: '@' // Força formato de texto
                                }}
                                label={sanitizeValue(a.label)}
                                value={a.value}
                            />
                        )
                    })}
                </ExcelSheet>
            </ExcelFile>

            {/* Botão para Exportação Personalizada */}
            <Button
                variant="outlined"
                color="primary"
                onClick={() => setShowCustomDialog(true)}
                startIcon={<Icon>tune</Icon>}
                style={{
                    marginLeft: '10px',
                    borderRadius: 8,
                    textTransform: 'none',
                    fontWeight: 600,
                    borderWidth: 2,
                    '&:hover': {
                        borderWidth: 2
                    }
                }}
            >
                Personalizar
            </Button>

            {/* Dialog de Exportação Personalizada */}
            <Dialog
                open={showCustomDialog}
                onClose={() => setShowCustomDialog(false)}
                maxWidth="lg"
                fullWidth
                className={classes.dialog}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Typography variant="h6">
                        <Icon style={{ fontSize: '1.3rem' }}>tune</Icon>
                        Personalizar Exportação
                    </Typography>
                </DialogTitle>

                <DialogContent className={classes.dialogContent}>
                    <Grid container spacing={2}>
                        {/* Configurações Gerais - Uma linha */}
                        <Grid item xs={12}>
                            <Card className={classes.sectionCard}>
                                <CardHeader
                                    className={classes.sectionHeader}
                                    avatar={<Icon color="primary" style={{ fontSize: '1.2rem' }}>settings</Icon>}
                                    title="Configurações da Exportação"
                                />
                                <CardContent className={classes.sectionContent}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                label="Nome do Arquivo"
                                                value={customExportOptions.fileName}
                                                onChange={(e) => handleCustomExportChange('fileName', e.target.value)}
                                                variant="outlined"
                                                size="small"
                                                className={classes.textField}
                                                InputProps={{
                                                    startAdornment: <Icon style={{ marginRight: 6, color: '#666', fontSize: '1rem' }}>insert_drive_file</Icon>
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                label="Aba Principal"
                                                value={customExportOptions.mainSheetName}
                                                onChange={(e) => handleCustomExportChange('mainSheetName', e.target.value)}
                                                variant="outlined"
                                                size="small"
                                                className={classes.textField}
                                                InputProps={{
                                                    startAdornment: <Icon style={{ marginRight: 6, color: '#666', fontSize: '1rem' }}>table_chart</Icon>
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                label="Aba de Usuários"
                                                value={customExportOptions.userSheetName}
                                                onChange={(e) => handleCustomExportChange('userSheetName', e.target.value)}
                                                variant="outlined"
                                                size="small"
                                                className={classes.textField}
                                                InputProps={{
                                                    startAdornment: <Icon style={{ marginRight: 6, color: '#666', fontSize: '1rem' }}>people</Icon>
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Opções de Abas e Preview */}
                        <Grid item xs={12} md={5}>
                            <Card className={classes.sectionCard}>
                                <CardHeader
                                    className={classes.sectionHeader}
                                    avatar={<Icon color="primary" style={{ fontSize: '1.2rem' }}>tab</Icon>}
                                    title="Abas a Incluir"
                                />
                                <CardContent className={`${classes.sectionContent} ${classes.compactSection}`}>
                                    <Box className={classes.switchContainer}>
                                        <Box display="flex" alignItems="center">
                                            <Icon style={{ marginRight: 6, color: '#1976d2', fontSize: '1rem' }}>table_view</Icon>
                                            <Typography variant="body2">
                                                Dados Principais
                                            </Typography>
                                        </Box>
                                        <Switch
                                            checked={customExportOptions.includeMainSheet}
                                            onChange={(e) => handleCustomExportChange('includeMainSheet', e.target.checked)}
                                            color="primary"
                                            size="small"
                                        />
                                    </Box>

                                    <Box className={classes.switchContainer}>
                                        <Box display="flex" alignItems="center">
                                            <Icon style={{ marginRight: 6, color: '#1976d2', fontSize: '1rem' }}>group</Icon>
                                            <Typography variant="body2">
                                                Usuários por Card
                                            </Typography>
                                        </Box>
                                        <Switch
                                            checked={customExportOptions.includeUserSheet}
                                            onChange={(e) => handleCustomExportChange('includeUserSheet', e.target.checked)}
                                            color="primary"
                                            size="small"
                                        />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Preview dos Dados */}
                        <Grid item xs={12} md={7}>
                            <Card className={classes.sectionCard}>
                                <CardHeader
                                    className={classes.sectionHeader}
                                    avatar={<Icon color="primary" style={{ fontSize: '1.2rem' }}>analytics</Icon>}
                                    title="Resumo da Exportação"
                                />
                                <CardContent className={`${classes.sectionContent} ${classes.compactSection}`}>
                                    <Box display="flex" flexWrap="wrap" gap={1}>
                                        <Chip
                                            label={`${dataSet.length} registros principais`}
                                            className={classes.previewChip}
                                            size="small"
                                            icon={<Icon style={{ fontSize: '14px' }}>table_rows</Icon>}
                                        />
                                        <Chip
                                            label={`${userDataSet.length} usuários`}
                                            className={classes.previewChip}
                                            size="small"
                                            icon={<Icon style={{ fontSize: '14px' }}>people</Icon>}
                                        />
                                        <Chip
                                            label={`${getExportPreview().totalSheets} ${getExportPreview().totalSheets === 1 ? 'aba' : 'abas'}`}
                                            className={classes.previewChip}
                                            size="small"
                                            icon={<Icon style={{ fontSize: '14px' }}>tab</Icon>}
                                        />
                                        <Chip
                                            label={`${getExportPreview().selectedColumns}/${columns.length} colunas`}
                                            className={classes.previewChip}
                                            size="small"
                                            icon={<Icon style={{ fontSize: '14px' }}>view_column</Icon>}
                                        />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Seleção de Colunas */}
                        <Grid item xs={12}>
                            <Card className={classes.sectionCard}>
                                <CardHeader
                                    className={classes.sectionHeader}
                                    avatar={<Icon color="primary" style={{ fontSize: '1.2rem' }}>view_column</Icon>}
                                    title="Selecionar Colunas para Exportação"
                                    subheader={`${Object.values(customExportOptions.selectedColumns).filter(Boolean).length} de ${columns.length} colunas selecionadas`}
                                />
                                <CardContent className={classes.sectionContent}>
                                    <Box mb={1.5} display="flex" gap={1}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() => {
                                                const allSelected = {}
                                                columns.forEach(col => allSelected[col.value] = true)
                                                setCustomExportOptions(prev => ({
                                                    ...prev,
                                                    selectedColumns: allSelected
                                                }))
                                            }}
                                            startIcon={<Icon style={{ fontSize: '1rem' }}>select_all</Icon>}
                                        >
                                            Todas
                                        </Button>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() => {
                                                setCustomExportOptions(prev => ({
                                                    ...prev,
                                                    selectedColumns: {}
                                                }))
                                            }}
                                            startIcon={<Icon style={{ fontSize: '1rem' }}>clear</Icon>}
                                        >
                                            Nenhuma
                                        </Button>
                                    </Box>

                                    <FormControl component="fieldset" fullWidth>
                                        <FormGroup>
                                            <Grid container spacing={0.5}>
                                                {columns.map((column, index) => (
                                                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                                        <Box className={classes.columnItem}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={customExportOptions.selectedColumns[column.value] || false}
                                                                        onChange={(e) => handleColumnSelectionChange(column.value, e.target.checked)}
                                                                        color="primary"
                                                                        size="small"
                                                                    />
                                                                }
                                                                label={
                                                                    <Typography variant="body2" style={{ fontSize: '0.8rem', lineHeight: 1.2 }}>
                                                                        {column.label}
                                                                    </Typography>
                                                                }
                                                            />
                                                        </Box>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </FormGroup>
                                    </FormControl>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions className={classes.actionButtons}>
                    <Button
                        onClick={() => setShowCustomDialog(false)}
                        className={classes.cancelButton}
                        startIcon={<Icon>close</Icon>}
                    >
                        Cancelar
                    </Button>
                    {renderCustomExport()}
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default ExportAll
